<ion-header>
  <ion-toolbar>
    <ion-title>Trocar senha</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="dismiss()">
        <ion-icon name="close" slot="icon-only" />
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding-start ion-padding-end">
  @if (!auth.hasAnyCustomClaims((auth.customClaims$ | async), ['manager', 'finance'])) {

    <form [formGroup]="newPasswordForm">
      <ion-item class="ion-no-padding">
        <ion-label position="stacked">
          <span class="big-label">Nova senha</span>
        </ion-label>
        <ion-icon color="primary" name="lock-closed-outline" slot="start" class="ion-align-self-end" />
        <ion-input type="password" formControlName="newPassword" />
      </ion-item>
      <ion-item class="ion-no-padding">
        <ion-label position="stacked">
          <span class="big-label">Confirmar nova senha</span>
        </ion-label>
        <ion-icon color="primary" name="lock-closed-outline" slot="start" class="ion-align-self-end" />
        <ion-input type="password" formControlName="confirmPassword" />
        @if (confirmPassword.errors?.['matching'] && (confirmPassword.dirty || confirmPassword.touched)) {
          <span slot="error">
            As senhas não conferem
          </span>
        }
        @if (newPassword.errors?.['minlength'] && (newPassword.dirty && newPassword.touched)) {
          <span slot="error">
            A senha deve ter um mínimo de 6 caracteres
          </span>
        }
      </ion-item>
      <ion-button expand="block" color="primary" (click)="confirmNewPassword()" class="big-margin" [disabled]="!newPasswordForm.valid || requesting">
        Redefinir senha
        @if (requesting) {
          <ion-spinner name="lines-small" slot="end" />
        }
      </ion-button>
      @if (errorMessage) {
        <ion-item lines="none" class="ion-no-padding">
          <ion-icon name="alert-circle-outline" slot="start" class="ion-align-self-end" color="danger" />
          <ion-label color="danger">{{ errorMessage }}</ion-label>
        </ion-item>
      }
    </form>
    <!-- Confirm password modal -->
    <ion-modal [isOpen]="isConfirmPasswordModalOpen" class="confirm-password-modal">
      <ng-template>
        <ion-toolbar>
          <ion-title>Confirmar senha</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="isConfirmPasswordModalOpen = false">
              <ion-icon color="primary" name="close" />
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
        <ion-content class="ion-padding" [scrollY]="false">
          <ion-item class="ion-no-padding">
            <ion-label position="stacked">
              <span class="big-label">Digite sua senha atual</span>
            </ion-label>
            <ion-icon color="primary" name="person-circle-outline" slot="start" class="ion-align-self-end" />
            <ion-input type="password" [(ngModel)]="currentPassword" />
          </ion-item>
          <div class="ion-padding">
            <ion-button
              color="primary"
              expand="block"
              [disabled]="!currentPassword"
              (click)="confirmCurrentPassword()"
              >CONFIRMAR
              @if (requesting) {
                <ion-spinner name="lines-small" slot="end" />
              }
            </ion-button>
          </div>
        </ion-content>
      </ng-template>
    </ion-modal>
  }
</ion-content>
